import mothersDayThumbnail from "@assets/images/GUIDThumbnails/mothers-day-thumbnail.avif";

export default function MothersDayThumbnail() {
  return (
    <svg
      viewBox="0 0 77 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
    >
      <image
        href={mothersDayThumbnail.src}
        width="77"
        height="64"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
}
